import React from "react";
import { connect } from "react-redux";

import ColorSetList from "./ColorSetList";

class PaperColor extends React.Component {
  render() {
    const layers = this.props.design.layer_set.map((layer) => {
      if (!layer.has_color && !layer.has_print_color) {
        return null;
      }

      if (
        layer.color_from_layer !== "" ||
        layer.print_color_from_layer !== ""
      ) {
        //if we're using a color from another layer, don't display the colors again
        return null;
      }

      let name = layer.has_color
        ? layer.color_setting_name
        : layer.print_color_setting_name;
      name = name + "s";
      let selectedColor = layer.has_color ? layer.color : layer.print_color;

      let colors = layer.has_color ? layer.colors : layer.print_colors;

      //print colors can use paper colors
      if (layer.has_print_color && layer.print_color_type === "Paper") {
        colors = layer.colors;
      }

      const type = layer.has_color ? "Paper" : "Print"; // this is NOT the color setting type
      if (!colors) {
        //make sure we don't pass an undefined var
        colors = [];
      }

      return (
        <div className="tool tool--color" key={layer.layer_id}>
          <h3 className="tool__section-header">{name}</h3>
          <div className="tool__options">
            <ColorSetList
              layerId={layer.layer_id}
              type={type}
              colorCategories={colors}
              selectedColor={selectedColor}
            />
          </div>
        </div>
      );
    });

    return <div className="tool--colors">{layers}</div>;
  }
}

function mapStateToProps(state) {
  return {
    design: state.design.present,
  };
}

export default connect(mapStateToProps)(PaperColor);
